const MODAL_TYPE = {
  DESCRIBE: "describe",
  PROJECT_COMPLETE: "project-complete",
  CONFIRM: "confirm",
  INVITE_MEMBER: "invite-member",
  TOPUP: "topup",
};

export { MODAL_TYPE };
